"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsMenu = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const ViewFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldRegistry"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const getViewFieldsFromQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getViewFieldsFromQuestions"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const SelfContext_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/SelfContext"));
const usePopDefinitions_1 = __importDefault(require("@opsbase/react-gql-hooks/popdefinition/usePopDefinitions"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewRegistryActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewRegistryActions"));
const DataIcon_1 = __importDefault(require("@opsbase/web-icons/DataIcon"));
const OpDefinitionIcon_1 = __importDefault(require("@opsbase/web-icons/icons/OpDefinitionIcon"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const SearchBox_1 = __importDefault(require("@opsbase/web-textfield/SearchBox"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const NonModalPopover_1 = __importDefault(require("@opsbase/web-ui/NonModalPopover"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importStar(require("react"));
const MAX_FIELDS_BEFORE_ADDING_CHARTS = 25;
function OpsMenu() {
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const { setView, cloneView } = (0, useViewRegistryActions_1.default)();
    const [showMainMenu, setShowMainMenu] = (0, react_1.useState)(false);
    const buttonRef = (0, react_1.useRef)();
    const [keyword, setKeyword] = (0, react_1.useState)('');
    const { loading, data } = (0, usePopDefinitions_1.default)({ variables: { keyword, latest: ['TRUE'] } });
    const { language } = (0, react_1.useContext)(SelfContext_1.default);
    const sortedData = (0, react_1.useMemo)(() => (data ? [...data].sort((a, b) => a.title.localeCompare(b.title)) : []), [data]);
    const opDefFilters = view.filters.filter(f => f.queryFieldKey === QueryFieldKey_1.default.OPDEFINITION);
    const handleClickButton = (0, react_1.useCallback)(() => {
        setShowMainMenu(true);
    }, []);
    const handleCloseMainMenu = (0, react_1.useCallback)(() => {
        setShowMainMenu(false);
    }, []);
    const handleToggle = (0, useCallforward_1.default)(popDef => () => {
        var _a, _b;
        const selectingAll = !popDef;
        const alreadyOn = !selectingAll && opDefFilters.find(f => f.id === popDef.opDefinitionId);
        const nextOpDefFilters = selectingAll
            ? []
            : alreadyOn
                ? opDefFilters.filter(f => f.id !== popDef.opDefinitionId)
                : [
                    ...opDefFilters,
                    {
                        queryFieldKey: QueryFieldKey_1.default.OPDEFINITION,
                        id: popDef.opDefinitionId,
                        title: popDef.title,
                    },
                ];
        const singleMode = (nextOpDefFilters === null || nextOpDefFilters === void 0 ? void 0 : nextOpDefFilters.length) === 1;
        let chartsVisible = view.chartBox.visible;
        let charts = view.chartBox.charts.filter(c => c.chartVariant !== ChartVariant_1.default.SCORE_Q_OP);
        let fields = view.fields
            .filter(f => f.key !== ViewFieldKey_1.default.ROWKEY)
            .filter(f => f.key !== ViewFieldKey_1.default.TITLE)
            .filter(f => f.key !== ViewFieldKey_1.default.QUESTIONANSWER);
        let filters = [
            ...view.filters.filter(fb => fb.queryFieldKey !== QueryFieldKey_1.default.OPDEFINITION),
            ...nextOpDefFilters.map(nextOpDef => (Object.assign(Object.assign({}, nextOpDef), { hidden: singleMode, veryHidden: singleMode }))),
        ];
        // SINGLE OP DEF MODE
        if (singleMode) {
            const singleOpDef = sortedData.find(d => d.opDefinitionId === nextOpDefFilters[0].id);
            fields = [
                ViewFieldRegistry_1.default[ViewFieldKey_1.default.ROWKEY],
                ...fields,
                ...(0, getViewFieldsFromQuestions_1.default)(singleOpDef.form, language),
            ];
            const sections = (_b = (_a = singleOpDef === null || singleOpDef === void 0 ? void 0 : singleOpDef.form) === null || _a === void 0 ? void 0 : _a.filter(q => q.type === FormQuestionType_1.default.SECTION)) !== null && _b !== void 0 ? _b : [];
            if (singleOpDef.isScoreEnabled &&
                ((fields === null || fields === void 0 ? void 0 : fields.length) <= MAX_FIELDS_BEFORE_ADDING_CHARTS ||
                    (sections.length > 0 && sections.length <= MAX_FIELDS_BEFORE_ADDING_CHARTS))) {
                chartsVisible = true;
                charts = [
                    {
                        key: 'scoreChart',
                        chartType: ChartType_1.default.BAR3DSTACK,
                        chartVariant: ChartVariant_1.default.SCORE_Q_OP,
                        config: {},
                    },
                    ...charts,
                ];
            }
        }
        // ALL or MULTI
        else {
            fields = [ViewFieldRegistry_1.default[ViewFieldKey_1.default.TITLE], ...fields];
        }
        const newView = cloneView(view.id);
        newView.isSystem = true;
        newView.groupsChanged = new Date();
        newView.filtersChanged = new Date();
        newView.fields = fields;
        newView.filters = filters;
        newView.chartBox = {
            visible: chartsVisible && !!charts.length,
            charts,
        };
        setView(newView, false, true);
    }, [opDefFilters, view, cloneView, setView, sortedData, language]);
    const buttonLabel = opDefFilters.length === 1
        ? opDefFilters[0].title
        : opDefFilters.length > 1
            ? lib_i18n_1.default.t('multiple-ops')
            : lib_i18n_1.default.t('all-ops');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { ref: buttonRef, style: { minHeight: 42 }, maxLabelWidth: 200, icon: react_1.default.createElement(OpDefinitionIcon_1.default, null), color: !!(opDefFilters === null || opDefFilters === void 0 ? void 0 : opDefFilters.length) ? lib_palette_1.default.secondary : lib_palette_1.default.BlackCoral, background: true, onClick: handleClickButton, label: buttonLabel }),
        showMainMenu && (react_1.default.createElement(NonModalPopover_1.default, { open: true, anchorEl: buttonRef.current, onClose: handleCloseMainMenu, placement: "bottom-start" },
            react_1.default.createElement(SearchBox_1.default, { keyword: keyword, onChange: setKeyword }),
            react_1.default.createElement(Spinner_1.default, { busy: loading },
                react_1.default.createElement("div", { style: { minWidth: 280, maxHeight: 400, overflow: 'auto' } },
                    react_1.default.createElement(MenuItem_1.default, { onClick: handleToggle(undefined), label: lib_i18n_1.default.t('all-ops'), icon: react_1.default.createElement(DataIcon_1.default, { type: DataType_1.default.OPDEFINITION }), showTick: !(opDefFilters === null || opDefFilters === void 0 ? void 0 : opDefFilters.length) }),
                    react_1.default.createElement(Divider_1.default, null),
                    !!sortedData &&
                        sortedData.map(popDef => (react_1.default.createElement(Tooltip_1.default, { key: popDef.opDefinitionId, enterDelay: 500, minTipLength: 20, tip: popDef.title },
                            react_1.default.createElement(MenuItem_1.default, { key: popDef.opDefinitionId, onClick: handleToggle(popDef), icon: react_1.default.createElement(DataIcon_1.default, { type: DataType_1.default.OPDEFINITION }), label: popDef.title, showTick: !!opDefFilters.find(f => f.id === popDef.opDefinitionId) }))))))))));
}
exports.OpsMenu = OpsMenu;
exports.default = OpsMenu;
